// extracted by mini-css-extract-plugin
module.exports = {"icon":"geolocation_icon__3IH9j","loading":"geolocation_loading__2LBUz","blinking":"geolocation_blinking__2_P4Y"};